
import vue from "vue";
import {
addDay,
setSessionStorage,
getSessionStorage,
removeSessionStorage
} from "@/common/js/utils.js";
import {
initWxJSSDK,
appointment,
getDefaultAddress,
checkOpenArea,
getPartner
} from "@/common/js/api.js";

import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import { getCookie } from "../common/js/utils";

export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle
},
methods: {
changeCondition() {
this.condition = !this.condition;
},
getResult(val) {
this.results = val ? getResult(this.value) : [];
},
onSubmit(val) {
let self = this;
if (this.entity.weight == "") {
this.view.toast = true;
this.view.toastText = "请选择重量";
return;
} else if (!this.entity.addressId) {
this.view.toast = true;
this.view.toastText = "请选择收件地址";
return;
} else if (!this.view.isAreaSupport) {
this.view.toast = true;
this.view.toastText = "当前地址暂未开通服务";
return;
} else if (this.entity.appointTime == "预约时间") {
this.view.toast = true;
this.view.toastText = "请选择预约时间";
return;
}
this.$vux.confirm.show({

title: "提醒您",
content: "确定本次预约吗？",
onCancel() {},
onConfirm() {
self.appointment();
}
});
},
appointment() {
let self = this;
appointment({ data: this.entity }).then(function(data) {









self.$router.push({ path: "/usercenter/orderList" });
});
},
onChange(v) {},

weightChange(v) {
console.log(v);
},
confirmWeight() {
if (this.view.weightDefault == 0) {
this.view.toast = true;
this.view.toastText = "5KG以下(暂不回收)";
} else {
this.view.openWeightPicker = !this.view.openWeightPicker;
this.entity.weight = this.getSelectValue(
this.view.weightDefault,
this.weights[0]
);
this.view.weightText = this.getSelectText(
this.view.weightDefault,
this.weights[0]
);
}
},
pickWeight(item) {
if (item.status == 0) {
return;
}
this.view.weightDefault = item.value;
},
getSelectText(val, ls) {
for (var i = 0; i < ls.length; i++) {
if (ls[i].value == val) {
return ls[i].name;
}
}
return "";
},
getSelectValue(val, ls) {
for (var i = 0; i < ls.length; i++) {
if (ls[i].value == val) {
return ls[i].value;
}
}
return "";
},
confirmTime() {
this.view.openTimePicker = !this.view.openTimePicker;
this.entity.appointTime = this.view.appointTimeDefault[0];





},
openPickAddress() {
setSessionStorage("pickAddress", "1");
this.$router.push({
path: '/usercenter/addressList',
query: { type: 'choice', partnerId: this.partnerId }
})
},
getDefaultAddress() {
let self = this;
if( this.$route.query.addressId && this.$route.query.areaCode && this.$route.query.addressText ){
self.entity.addressId = this.$route.query.addressId;
self.view.areaCode = this.$route.query.areaCode;
self.view.address = unescape(this.$route.query.addressText);
}else{
getDefaultAddress({ data: {} }).then(function(data) {
if (data.Content) {
self.entity.addressId = data.Content.recordID;
self.view.address = data.Content.areaCodeText;
self.view.areaCode = data.Content.areaCode;
self.checkOpenArea();
}
});
}
},
checkOpenArea() {
let self = this;
self.view.isAreaSupport = false;
checkOpenArea({ data: { areaCode: self.view.areaCode } }).then(function(
data
) {
if (data.Code == 200) {
self.view.isAreaSupport = true;
}
});
},
initShare() {
let self = this;
self.$wechat.onMenuShareTimeline({
title: self.share.shareTitle, // 分享标题
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
success: function() {















},
cancel: function() {

}
});
self.$wechat.onMenuShareAppMessage({
title: self.share.shareTitle,
link: self.share.shareUrl, // 分享链接
imgUrl:
window.location.protocol +
"//" +
window.location.hostname +
"/static/images/logo.png", // 分享图标
desc: self.share.shareDesc,
type: "link",
dataUrl: "",
success: function() {




},
cancel: function() {

}
});
}
},
data() {
return {
fromWhere: this.$route.query.fromWhere,
activityId: this.$route.query.activityId,
partner: {},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: "",
extInfo: undefined
},
view: {
openWeightPicker: false,
toast: false,
toastText: "",
openTimePicker: false,
openAddressPicker: false,
weightText: "重量",
appointTimeDefault: [],
weightDefault: "2",
address: "",
areaCode: "",
isAreaSupport: false
},
entity: {
weight: "",
appointTime: "预约时间",
addressId: ""
},
weights: [
[
{ name: "5KG以下(暂不回收)", value: "0", status: 0 },
{ name: "5-15KG(约17件)", value: "1", status: 1 },
{ name: "15-25KG(约37件)", value: "2", status: 1 },
{ name: "25-35KG(约60件)", value: "3", status: 1 },
{ name: "35KG以上(约75件以上)", value: "4", status: 1 }
]
],
times: [],
share: {
shareTitle: "闲置衣物回收",
shareDesc: "闲置衣物回收",
shareUrl: ""
},
partnerId: "",
appointImage: "",
btnStyle: "",
bannerImage: ""
};
},
created() {


let self = this;
self.partnerId = this.$route.query.partnerId;
self.entity.partnerId = self.partnerId;
if (this.$route.query.autoSupport) {
self.entity.autoSupport = this.$route.query.autoSupport;
}

var sharePartner = self.partnerId
? "&invitePartnerId=" + self.partnerId + "&partnerId=" + self.partnerId
: "";
if (this.$route.query.partnerId) {
getPartner({ data: { partnerId: self.partnerId } }).then(function(data) {
console.log(data)
if (data.Content) {
self.partner = data.Content;
if (data.Content.appointImages) {
self.appointImage = data.Content.appointImages;
} else {
self.appointImage = "../../static/images/intro.jpg?v=2";
}
console.log(self.appointImage);

if (self.partner.color) {
self.btnStyle = "background:#" + self.partner.color + "!important";
}
if (self.partner.banner) {
self.bannerImage = self.partner.banner;
} else {
self.bannerImage = "../../static/images/ad1.jpg";
}
} else {
self.appointImage = "../../static/images/intro.jpg?v=2";
self.bannerImage = "../../static/images/ad1.jpg";
}
});
} else {
















self.appointImage = "../../static/images/intro.jpg?v=2";
self.bannerImage = "../../static/images/ad1.jpg";


}

self.share.shareUrl =
window.location.protocol +
"//" +
window.location.hostname +
"/menu/appointment/" +
getCookie("authorizer_appid") +
"?k=1" +
sharePartner;

initWxJSSDK();
vue.wechat.ready(function(res) {
self.initShare();
});
let days = [];
let now = new Date();
let j = 0
for (var i = 0; i < 7; i++) {
let d = addDay(now, i + 1);
let date = d.Format("yyyy-MM-dd")
const dateArr = date.split('-')
const month = parseInt(dateArr[1])
const day = parseInt(dateArr[2])

if (month == 2 && day >= 11 && day <= 18) {
d = addDay('2021-02-18', j)
date = d.Format("yyyy-MM-dd")
j++
}

if (i == 0) {
days.push(date);
this.view.appointTimeDefault.push(date);
} else {
days.push(date);
}
}
this.times.push(days);
this.getDefaultAddress();
},
activated() {
let self = this;
let pickAddress = getSessionStorage("pickAddress");
if (pickAddress == "1") {
if (this.$route.query.addressId) {
this.entity.addressId = this.$route.query.addressId;
this.view.address = unescape(this.$route.query.addressText);
self.view.areaCode = this.$route.query.areaCode;
removeSessionStorage("pickAddress");
self.checkOpenArea();
}
}

if (this.$route.query.activityId) {
this.entity.activityId = this.$route.query.activityId;
}

let user = getCookie("user");
if (user) {
user = JSON.parse(user);
if (user.phoneCertification == 0) {
self.$router.replace({ path: "/mobileAuth" });
}
}
}





};



// WEBPACK FOOTER //
// ./src/components/Home.vue